export const CALL_API = Symbol('CALL API');

export default () => next => async (action) => {
    const callApi = action[CALL_API];

    if (typeof callApi === 'undefined') {
        return next(action);
    }

    const { types, request, params } = callApi;

    const actionWith = (data) => {
        const finalAction = Object.assign({}, action, data);
        delete finalAction[CALL_API];
        return finalAction;
    };

    const [
        requestType,
        successType,
        errorType
    ] = types;

    next(actionWith({ type: requestType, params }));

    try {
        const response = await request(params);
        return next({
            response,
            type: successType,
        });
    } catch (error) {
        return next({
            error: error.message,
            type: errorType,
            params,
        })
    }
};